export const breakpoints = {
  tablet: 1000,
  desktop: 1100,
  mobile: 767
};
